import React, { useState } from 'react';
import { LoadingButton } from '@atlaskit/button';
import { useForm } from 'react-hook-form';
import RenderForm from '../shared/RenderForm';
import RedirectAfterSuccessAction from '../shared/RedirectToActivation';
import BackToLogin from '../shared/BackToLogin';
import { iHookFormField, iKeyValuePairs } from '../../../shared/UITypes/types';
import { SpaceVerticalContainer } from '../../../shared/styles/styles';
import { apiErrorToast } from '../../../shared/toast/Toast';
import { activateCompany } from '../../../services/AuthService';
import { ACTIVATION_SUCCESS_HINT } from '../shared/Auth.constants';
import { addCompareRules, generateInitialValues } from '../shared/Form.utils';

type iState = {
  isLoading: boolean;
  success: boolean;
};
const initialState: iState = {
  isLoading: false,
  success: false,
};
const UserActivateForm = ({
  fields,
  onSubmitExtraFields,
}: {
  fields: Array<iHookFormField>;
  onSubmitExtraFields?: iKeyValuePairs;
}) => {
  const [state, setState] = useState(initialState);
  const { control, errors, handleSubmit, getValues } = useForm({
    mode: 'onBlur',
    defaultValues: generateInitialValues(fields),
    reValidateMode: 'onBlur',
  });

  // eslint-disable-next-line
  const onSubmit = async (data: any) => {
    setState({ ...state, isLoading: true });
    try {
      await activateCompany({
        ...data,
        ...onSubmitExtraFields,
      });
      setState({
        ...state,
        isLoading: false,
        success: true,
      });
    } catch (error) {
      apiErrorToast(error);
      setState({ ...state, isLoading: false });
    }
  };

  return (
    <>
      {state.success ? (
        <RedirectAfterSuccessAction message={ACTIVATION_SUCCESS_HINT}>
          <BackToLogin />
        </RedirectAfterSuccessAction>
      ) : (
        <>
          <RenderForm
            control={control}
            fields={addCompareRules(fields, getValues)}
            errors={errors}
          />
          <SpaceVerticalContainer className={'half'} />
          <LoadingButton
            appearance={'primary'}
            isLoading={state.isLoading}
            shouldFitContainer
            onClick={handleSubmit(onSubmit)}
          >
            Activate
          </LoadingButton>
        </>
      )}
    </>
  );
};

export default UserActivateForm;
